import { getDomain, tougaoInfo, tougaoSetting, tougaoBanners, tougaosCategorys } from '@/api/Tougaos'

const state = {
    tougaoInfo: '',
    tougaoSetting: {},
    memberSetting: [],
    memberSettingEn: [],
    zuopinSetting: [],
    zuopinSettingEn: [],
    categoryList: [],
    categoryListEn: [],
    bannerList: [],
    domain: {}
}

const mutations = {
    SET_DOMAIN: (state, domain) => {
        state.domain = domain
    },
    SET_TOUGAOINFO: (state, tougaoInfo) => {
        state.tougaoInfo = tougaoInfo
    },
    SET_TOUGAOSETTING: (state, tougaoSetting) => {
        state.tougaoSetting = tougaoSetting
    },
    SET_MEMBERSETTING: (state, memberSetting) => {
        state.memberSetting = memberSetting
    },
    SET_MEMBERSETTINGEN: (state, memberSettingEn) => {
        state.memberSettingEn = memberSettingEn
    },
    SET_ZUOPINSETTING: (state, zuopinSetting) => {
        state.zuopinSetting = zuopinSetting
    },
    SET_ZUOPINSETTINGEN: (state, zuopinSettingEn) => {
        state.zuopinSettingEn = zuopinSettingEn
    },
    SET_CATEGORYLIST: (state, categoryList) => {
        state.categoryList = categoryList
    },
    SET_CATEGORYLISTEN: (state, categoryListEn) => {
        state.categoryListEn = categoryListEn
    },
    SET_BANNERLIST: (state, bannerList) => {
        state.bannerList = bannerList
    }
}

const actions = {
    getTouGaoInfo({ commit }, params) {
        return new Promise((resolve, reject) => {
            tougaoInfo(params).then(res => {
                if (res.code === 200) {
                    commit('SET_TOUGAOINFO', res.data)
                    resolve(res.data)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    getTouGaoSetting({ commit }, params) {
        return new Promise((resolve, reject) => {
            tougaoSetting(params).then(res => {
                if (res.code === 200) {
                    const { member_settings, member_settings_en, zuopin_settings, zuopin_settings_en } = res.data
                    commit('SET_TOUGAOSETTING', res.data)
                    commit('SET_MEMBERSETTING', member_settings)
                    commit('SET_MEMBERSETTINGEN', member_settings_en)
                    commit('SET_ZUOPINSETTING', zuopin_settings)
                    commit('SET_ZUOPINSETTINGEN', zuopin_settings_en)

                    // // 人员
                    // commit('SET_MEMBERSETTING', res.data.member_settings)
                    // const member_settings_en = []
                    // res.data.member_settings.forEach(item => {
                    //     const { title_en, ...rest } = item
                    //     if (title_en) {
                    //         rest.title = title_en
                    //     }

                    //     if (rest.props.placeholder_en) {
                    //         const { placeholder_en, ...rest_props } = rest.props
                    //         rest_props.placeholder = placeholder_en
                    //         rest.props = rest_props
                    //     }

                    //     member_settings_en.push(rest)
                    // })
                    // commit('SET_MEMBERSETTINGEN', member_settings_en)
                    // console.log('member_settings_en', member_settings_en)

                    // // 作品
                    // commit('SET_ZUOPINSETTING', res.data.zuopin_settings)
                    // const zuopin_settings_en = []
                    // res.data.member_settings.forEach(item => {
                    //     const { title_en, ...rest } = item

                    //     if (rest.props.placeholder_en) {
                    //         const { placeholder_en, ...rest_props } = rest.props
                    //         rest_props.placeholder = placeholder_en
                    //         rest.props = rest_props
                    //     }

                    //     rest.title = title_en
                    //     zuopin_settings_en.push(rest)
                    // })
                    // commit('SET_ZUOPINSETTINGEN', zuopin_settings_en)
                    // console.log('zuopin_settings_en', member_settings_en)

                    resolve(res.data)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    getCategoryList({ commit }, params) {
        return new Promise((resolve, reject) => {
            tougaosCategorys(params).then(res => {
                const { cn, en } = res.data
                commit('SET_CATEGORYLIST', cn)
                commit('SET_CATEGORYLISTEN', en)
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getBanner({ commit }, params) {
        return new Promise((resolve, reject) => {
            tougaoBanners(params).then(res => {
                if (res.code === 200) {
                    const { list } = res.data
                    commit('SET_BANNERLIST', list)
                    resolve(list)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    getDomain({ commit }) {
        return new Promise((resolve, reject) => {
            getDomain().then(res => {
                if (res.code === 200) {
                    const { data } = res
                    commit('SET_DOMAIN', data)
                    resolve(data)
                }
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

